class ActiveCartDisplay extends HTMLElement {
  connectedCallback() {
    this.viewersEl = this.querySelector("[data-acd-viewers]");
    this.stockEl = this.querySelector("[data-acd-stock]");
    this.reservedEl = this.querySelector("[data-acd-reserved]");
    this.barEl = this.querySelector("[data-acd-bar]");

    this.viewersTemplate = this.dataset.viewersTemplate || "{count} athletes are viewing this right now";
    this.stockTemplate = this.dataset.stockTemplate || "Only {count} {package} left at this price";
    this.reservedTemplate = this.dataset.reservedTemplate || "Cart reserved · {time}";

    this.min = this.toInt(this.dataset.viewersMin, 21);
    this.max = Math.max(this.min, this.toInt(this.dataset.viewersMax, 47));
    this.step = Math.max(1, this.toInt(this.dataset.viewersStep, 5));
    this.interval = Math.max(1, this.toInt(this.dataset.viewersInterval, 4)) * 1000;

    this.remaining = Math.max(0, this.toInt(this.dataset.reservedSeconds, 600));
    this.onExpire = this.dataset.onExpire || "keep";
    this.startSeconds = this.remaining;

    this.variants = this.readData();
    this.viewers = this.randomInt(this.min, this.max);
    this.renderViewers();

    this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!this.reducedMotion) {
      this.viewersTimer = setInterval(() => this.tickViewers(), this.interval);
    }
    this.countdownTimer = setInterval(() => this.tickCountdown(), 1000);

    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const variant = event?.data?.variant;
        if (variant && variant.id) this.setVariant(variant.id);
      });
    }
  }

  disconnectedCallback() {
    clearInterval(this.viewersTimer);
    clearInterval(this.countdownTimer);
    if (typeof this.unsubscribe === "function") this.unsubscribe();
  }

  toInt(value, fallback) {
    const parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  readData() {
    const script = this.querySelector("[data-acd-data]");
    if (!script) return {};
    try {
      return JSON.parse(script.textContent) || {};
    } catch (error) {
      return {};
    }
  }

  tickViewers() {
    let delta = this.randomInt(-this.step, this.step);
    if (delta === 0) delta = Math.random() < 0.5 ? -1 : 1;

    let next = this.viewers + delta;
    if (next < this.min) next = this.min + Math.abs(delta);
    if (next > this.max) next = this.max - Math.abs(delta);
    this.viewers = Math.min(this.max, Math.max(this.min, next));

    this.renderViewers();
  }

  renderViewers() {
    if (!this.viewersEl) return;
    this.viewersEl.textContent = this.viewersTemplate.replace("{count}", String(this.viewers));
  }

  setVariant(variantId) {
    const data = this.variants[String(variantId)];
    if (!data) return;

    if (this.stockEl) {
      this.stockEl.textContent = this.stockTemplate
        .replace("{count}", String(data.left))
        .replace("{package}", data.package || "");
    }

    if (this.barEl) {
      const fill = Math.min(100, Math.max(0, Number(data.fill) || 0));
      this.barEl.style.setProperty("--wt-acd-fill", `${fill}%`);
      this.barEl.setAttribute("aria-valuenow", String(fill));
      if (this.stockEl) this.barEl.setAttribute("aria-label", this.stockEl.textContent);
    }
  }

  tickCountdown() {
    if (this.remaining > 0) {
      this.remaining -= 1;
      this.renderCountdown();
      return;
    }

    if (this.onExpire === "restart") {
      this.remaining = this.startSeconds;
      this.renderCountdown();
      return;
    }

    if (this.onExpire === "hide" && this.reservedEl) {
      this.reservedEl.hidden = true;
    }
    clearInterval(this.countdownTimer);
  }

  renderCountdown() {
    if (!this.reservedEl) return;
    const minutes = Math.floor(this.remaining / 60);
    const seconds = this.remaining % 60;
    const clock = `${minutes}:${String(seconds).padStart(2, "0")}`;
    this.reservedEl.textContent = this.reservedTemplate.replace("{time}", clock);
  }
}

if (!customElements.get("active-cart-display")) {
  customElements.define("active-cart-display", ActiveCartDisplay);
}
